import React from 'react';

export const Danger = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.98 13.6684H13.02C14.0467 13.6684 14.6867 12.5551 14.1733 11.6684L9.15333 2.99508C8.64 2.10841 7.36 2.10841 6.84667 2.99508L1.82667 11.6684C1.31333 12.5551 1.95333 13.6684 2.98 13.6684ZM8 9.00175C7.63333 9.00175 7.33333 8.70175 7.33333 8.33508V7.00175C7.33333 6.63508 7.63333 6.33508 8 6.33508C8.36667 6.33508 8.66667 6.63508 8.66667 7.00175V8.33508C8.66667 8.70175 8.36667 9.00175 8 9.00175ZM8.66667 11.6684H7.33333V10.3351H8.66667V11.6684Z"
      fill="#DA1E28"
    />
  </svg>
);
